/**
 * Event related constants.
 */
const EventConstants = {
    EVENT_TERM_REGION: "Event Regions",
    EVENT_TERM_PRODUCT_INTEREST: "Event Product Interests",
    EVENT_TERM_EVENT_TYPE: "Event Types",
    EVENT_NO_RECORDS: "event.no-results-text",
    EVENT_CLEAR_FILTERS: "event.clear-filter",
    EVENT_KEYWORD_PLACEHOLDER: "event.search-text",
    EVENT_NUMBER_PER_PAGE: 5,
};

/**
 * Mapping of event taxonomy terms to their corresponding fields in the data model.
 */
const TaxonomyMapping = {
    [EventConstants.EVENT_TERM_REGION]: "regions",
    [EventConstants.EVENT_TERM_PRODUCT_INTEREST]: "interests",
    [EventConstants.EVENT_TERM_EVENT_TYPE]: "eventTypes",
};

/**
 * Exporting the constants and mappings.
 */
export { EventConstants, TaxonomyMapping };
